import useDeclarations from 'hooks/useDeclarations';
import useFormUtils from 'hooks/useFormUtils';
import { getProductsTotalConfig } from './productsTotalConfig';
import ProductsTotalValue from './ProductsTotalValue';

type Props = {
    declarationId: string | undefined;
    // Changed by the listing whenever its items are removed or changed, to fetch the total again.
    refreshKey: number;
};

const ProductsTotal = ({ declarationId, refreshKey }: Props) => {
    const { countryLowerCase: country, internalType } = useFormUtils();
    const { declaration } = useDeclarations();
    const config = getProductsTotalConfig(country, internalType);

    // The store can still hold the previously opened declaration, which would pair its currency with this total.
    const isDeclarationLoaded = declaration?.id === declarationId;

    if (!config || !declarationId || !isDeclarationLoaded) return null;

    const currency = config.getCurrency(declaration);

    // The key resets the shown total when another declaration is opened.
    return (
        <ProductsTotalValue
            key={declarationId}
            declarationId={declarationId}
            request={config.request}
            currency={currency}
            refreshKey={refreshKey}
        />
    );
};

export default ProductsTotal;
